<template>
    <section class="gmp-section gmp-mb-l">

        <div class="subpage-hero">
            <div class="two-column-tout">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6 h-c-grid__col-xl--5  h-c-grid__col--align-middle
            two-column-tout__content">
                            <h1 class="h-c-headline h-c-headline--display-two h-has-bottom-margin">
                                吸引更多新的加盟商加入
                            </h1>
                            <div class="h-u-mb-std two-column-tout__description">
                                <p>
                                    通过“时鲜管理”等小程序，加盟连锁餐饮企业可以为加盟商提供强有力的支持，降低运营风险，
                                    提升盈利能力和市场竞争力，最终增强加盟商的信心和满意度。
                                </p>
                            </div>

                        </div>

                        <div class="h-c-grid__col  h-c-grid__col-l--6  h-c-grid__col--align-middle">
                            <div class="two-column-tout__image text-center">
                                <picture>
                                    <img src="@/assets/img/jiamengBen.png" alt="" class="gmp-no-grab ">
                                </picture>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>

    </section>
</template>

<script>
    export default {
        name: "FS_subpagehero"
    }
</script>

<style lang="less">


</style>